import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrepareGuard, AuthGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { NominationOverviewComponent } from './nomination-overview/nomination-overview.component';
import { ProposalOverviewComponent } from './proposal-overview/proposal-overview.component';
import { ProposalDialogComponent } from './proposal-dialog/proposal-dialog.component';
import { ProposalVoteDialogComponent } from './proposal-vote-dialog/proposal-vote-dialog.component';
import { ProposalEmailDialogComponent } from './proposal-email-dialog/proposal-email-dialog.component';
import { AttachmentOverviewComponent } from './attachment-overview/attachment-overview.component';
import { AttachmentDialogComponent } from './attachment-dialog/attachment-dialog.component';
import { ReportComponent } from '../giving/report/report.component';
import { MinutesOverviewComponent } from './minutes-overview/minutes-overview.component';
import { CommitteeOverviewComponent } from '../people/committee-overview/committee-overview.component';
import { MinutesEmailDialogComponent } from './minutes-email-dialog/minutes-email-dialog.component';
import { NominationSettingDialogComponent } from './nomination-setting-dialog/nomination-setting-dialog.component';
import { NominationTallyComponent } from './nomination-tally/nomination-tally.component';
import { AgendaOverviewComponent } from './agenda-overview/agenda-overview.component';
import { EmailHistoryComponent } from './email-history/email-history.component';
import { CommitteePortalComponent } from 'app/member-portal/committee-portal/committee-portal.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'executive',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'nominations', component: NominationOverviewComponent, data: { title: 'Nominations' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'proposals', component: ProposalOverviewComponent, data: { title: 'Proposals' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'documents', component: AttachmentOverviewComponent, data: { title: 'Documents' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'minutes', component: MinutesOverviewComponent, data: { title: 'Minutes' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'reports', component: ReportComponent, data: { title: 'Reports' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'committee-list', component: CommitteeOverviewComponent, data: { title: 'Committees' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'nomination-tally', component: NominationTallyComponent, data: { title: 'Tally' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'agenda', component: AgendaOverviewComponent, data: { title: 'Agenda' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'agendanew', component: CommitteePortalComponent, data: { title: 'Agenda', mode: 'executive' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'emails', component: EmailHistoryComponent, data: { title: 'Emails' }, canActivate: [AuthGuard, PrepareGuard] },
                    // { path: 'background-checks', component: BackgroundChecksComponent, data: { title: 'Background Checks' }, canActivate: [AuthGuard, PrepareGuard] },
                    // { path: ':id', component: DetailComponent, data: { title: 'People' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        NominationOverviewComponent,
        ProposalOverviewComponent,
        ProposalDialogComponent,
        ProposalVoteDialogComponent,
        ProposalEmailDialogComponent,
        AttachmentOverviewComponent,
        AttachmentDialogComponent,
        MinutesOverviewComponent,
        MinutesEmailDialogComponent,
        NominationSettingDialogComponent,
        NominationTallyComponent,
        AgendaOverviewComponent,
        EmailHistoryComponent,
    ],
    exports: [],
})
export class ExecutiveModule {}
